import React from 'react';
import Helmet from 'react-helmet';
import Intercom from 'react-intercom';

import { intercomAppID } from 'src/config';

class App extends React.Component {
  render() {
    return (
      <div id="app">
        <Helmet
          htmlAttributes={{ lang: 'en' }}
          titleTemplate="Playerbase: %s"
          defaultTitle="Playerbase"
        />
        {this.props.children}
        <Intercom appID={intercomAppID} custom_launcher_selector=".intercom" />
      </div>
    );
  }
}

App.propTypes = {};
App.defaultProps = {};

export default App;



// WEBPACK FOOTER //
// ./src/App.js